import request from '@/utils/request'
/**
 * 获取api分组列表数据
 */
export const getApiGroupLists = (data) => {
    return request({
        url: '/openapi/group/lists',
        params: data
    })
}
/**
 * api分组-单条详情
 */
export const getApiGroupDetail = (id) => {
    return request({
        url: `/openapi/group/${id}`
    })
}
/**
 * 获取api分组选项列表数据
 */
export const getApiGroupOptionLists = (data) => {
    return request({
        url: '/openapi/group/option/lists',
        params: data
    })
}
/**
 * 新增api分组
 */
export const addApiGroup = (data) => {
    return request({
        url: '/openapi/group/manage',
        method: 'POST',
        data
    })
}
/**
 * api分组-编辑
 */
export const putApiGroup = (data) => {
    return request({
        url: '/openapi/group/manage',
        method: 'PUT',
        data
    })
}
/**
 * api分组-删除
 */
export const delApiGroup = (id) => {
    return request({
        url: `/openapi/group/${id}`,
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/post/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/post/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/openapi/group/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
